import Customization from "./customization";
import { StoreCategory, liquid } from "./customization/category";
import BaseCustomization from "./customization/base";
import CustomizationRequest from "./customization/request";

// Connects to data-controller="site-builder--layout"
export default class extends BaseCustomization {
  static targets = ["selection", "reset"];
  customizationType = "layoutId";

  initialize() {
    this.tabItem = document.getElementById("for-layouts");
  }

  initializeSelection() {
    const defaultValue = this.values();
    if (defaultValue) {
      this.#selectByValue(defaultValue);
    } else {
      Customization.localUpdate(
        { layout: this.selectionTarget.dataset?.[this.customizationType] },
        StoreCategory.LIQUID
      );
      this.removeSelectedOption();
      this.selectionTarget.classList.add("selected");
    }
    this.highlightTabSelection();
  }

  apply(e) {
    const chosen = e.currentTarget;
    const id = chosen.dataset[this.customizationType];

    if (this.isCustomizationSame(chosen)) return;
    Customization.serverUpdate({
      layout: id,
    });
    this.removeSelectedOption();
    this.showReset();
    e.currentTarget.classList.add("selected");
    e.preventDefault();
  }

  reset() {
    if (this.isPersisted) {
      Customization.serverUpdate({
        layout: undefined,
      });
    } else {
      Customization.serverUpdate({
        layout: this.selectionTarget.dataset?.[this.customizationType],
      });
      this.selectionTarget.classList.add("selected");
    }

    this.removeSelectedOption();
    this.hideReset();
  }

  #selectByValue(value) {
    const current = this.selectionTargets.find(
      (selection) => selection.dataset[this.customizationType] === value
    );

    if (current) {
      this.removeSelectedOption();
      current.classList.add("selected");
    }
  }

  fetchFromStore() {
    return liquid.layout;
  }

  fetchFromPreview() {
    return CustomizationRequest.getLayoutId();
  }
}
